module.exports = __webpack_public_path__ + "static/media/movementArrowLeft.b338e0df.svg";